<div class="container input-form">


  <form class="form-st" [formGroup]="contactForm">
    <div class="form-group col lab-0">
      <label for="inputEmail4" class="visible-label"> Fields <em class="em-style">*</em></label>
    </div>
    <div class="row sp-fm0">
      <div class="col dis_1">
        <input type="text" class="form-control" placeholder="First Name *" aria-label="First Name *" formControlName="FirstName">
        <span class="error errorFirstName">First name is </span>
        <span class="error invalidFirstName">First name is invalid</span>
      </div>
      <div class="col dis_1">
        <input type="text" class="form-control" placeholder="Last Name *" aria-label="Last Name *" formControlName="LastName">
        <span class="error errorLastName">Last name is </span>
        <span class="error invalidLastName">Last name is invalid</span>
      </div>
    </div>
    <div class="row sp-fm0">
      <div class="col dis_1 ">
        <input type="text" class="form-control" aria-label="Company Name *" placeholder="Company Name *"
          formControlName="CompanyName">
        <span class="error errorCompanyName">Company name is </span>
        <span class="error invalidCompanyName">Company name is invalid</span>
      </div>
      <div class="col dis_1">
        <select id="inputState" aria-label="Country" class="form-select ds" formControlName="Country">
          <option label="Country or Territory *" value="" disabled selected>Country or Territory *
          </option>
          <option label="Belgium" value="BE">Belgium</option>
          <option label="Canada" value="CA">Canada</option>
          <option label="China" value="CN">China</option>
          <option label="France" value="FR">France</option>
          <option label="Germany" value="DE">Germany</option>
          <option label="Hong Kong" value="HK">Hong Kong</option>
          <option label="Italy" value="IT">Italy</option>
          <option label="Mexico" value="MX">Mexico</option>
          <option label="Netherlands" value="NL">Netherlands</option>
          <option label="Poland" value="PL">Poland</option>
          <option label="Spain" value="ES">Spain</option>
          <option label="Thailand" value="TH">Thailand</option>
          <option label="United Kingdom" value="GB">United Kingdom</option>
          <option label="United States" value="US">United States</option>
        </select>
        <span class="error errorCountry">Country is </span>
        <span class="error invalidCountry">Country is invalid</span>
      </div>
    </div>
    <div class="row row-new sp-fm0">
      <div class="col  col-xs-12 col-md-12 col-lg-3 dis_1 side-by-side-rowsZip">
        <div class="hero-panel-button sli-btn form-submit">
          <button class="get-secret-btn form-sub submit-form" tabindex="-1" type="submit" (click)="validateFormDetails()">Submit
          </button>
        </div>
      </div>


    </div>

  </form>
</div>